import { render, staticRenderFns } from "./stu-service-appoint.vue?vue&type=template&id=25aa2bee&scoped=true"
import script from "./stu-service-appoint.vue?vue&type=script&lang=js"
export * from "./stu-service-appoint.vue?vue&type=script&lang=js"
import style0 from "./stu-service-appoint.vue?vue&type=style&index=0&id=25aa2bee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aa2bee",
  null
  
)

export default component.exports